"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isShowHideDisplayCondition = exports.isWorkOrderPrefillDisplayCondition = exports.isPrefillDisplayCondition = void 0;
function isPrefillDisplayCondition(c) {
    return c.action === "PREFILL";
}
exports.isPrefillDisplayCondition = isPrefillDisplayCondition;
function isWorkOrderPrefillDisplayCondition(c) {
    return c.action === "WORK_ORDER_PREFILL";
}
exports.isWorkOrderPrefillDisplayCondition = isWorkOrderPrefillDisplayCondition;
function isShowHideDisplayCondition(c) {
    return c.action === "SHOW" || c.action === "HIDE";
}
exports.isShowHideDisplayCondition = isShowHideDisplayCondition;
//# sourceMappingURL=displayConditionDTO.js.map